export default function ResumeCTA() {
  return (
    <section className="relative min-h-[420px] md:min-h-[520px] flex items-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dark%20geometric%20shapes%20futuristic%20lines%20network%20grid%20deep%20space%20dark%20charcoal%20background%20digital%20art%20tech%20minimal%20cinematic%20wide&width=1440&height=600&seq=cta1&orientation=landscape"
          alt="CTA Background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gray-950/75"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-10">
          {/* Left */}
          <div className="max-w-xl">
            <span className="inline-block text-emerald-400 text-xs font-mono tracking-widest uppercase mb-4">
              — Open to opportunities
            </span>
            <h2
              className="text-4xl md:text-6xl font-bold text-white leading-tight mb-5"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              Let's build
              <br />
              something great
              <br />
              <span className="text-emerald-400">together.</span>
            </h2>
            <p className="text-gray-400 text-base leading-relaxed">
              Available for full-time roles, contract work, and freelance projects.
              I'm always excited to collaborate on impactful problems.
            </p>
          </div>

          {/* Right */}
          <div className="flex flex-col gap-4">
            <a
              href="/resume_2026_.pdf"
              download
              className="inline-flex items-center justify-between gap-4 px-6 py-4 bg-white text-gray-900 font-semibold rounded-2xl hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap group"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-emerald-50 text-emerald-600">
                  <i className="ri-file-pdf-line text-xl"></i>
                </div>
                <div>
                  <div className="text-sm font-bold">Download Resume</div>
                  <div className="text-xs text-gray-500 font-normal">PDF · Updated 2026</div>
                </div>
              </div>
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-900 text-white group-hover:bg-emerald-500 transition-colors">
                <i className="ri-download-line"></i>
              </div>
            </a>

            <a
              href="mailto:contact@gmarostica.dev"
              className="inline-flex items-center justify-between gap-4 px-6 py-4 border border-white/20 text-white font-semibold rounded-2xl hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap group"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-white/10 text-white">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <div>
                  <div className="text-sm font-bold">Send an Email</div>
                  <div className="text-xs text-gray-400 font-normal">contact@gmarostica.dev</div>
                </div>
              </div>
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 text-white group-hover:bg-emerald-500 transition-colors">
                <i className="ri-arrow-right-line"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}